import React from 'react';
import { FaHeart } from 'react-icons/fa';

const Footer: React.FC = () => {
  // 打开指定网页的函数
  const openWebsite = () => {
    window.open('https://prismatic-sprinkles-2f2c01.netlify.app/', '_blank');
  };

  return (
    <footer className="bg-dark-800 border-t border-dark-600 py-2 px-4">
      <div className="w-full flex flex-col md:flex-row items-center justify-between text-dark-300 text-xs">
        <div className="mb-1 md:mb-0 ml-0">
          <p className="text-xs">
            AI绘画助手 &copy; {new Date().getFullYear()}
          </p>
        </div>
        <div className="flex items-center mr-0">
          <button
            onClick={openWebsite}
            className="text-dark-300 hover:text-white transition-colors flex items-center cursor-pointer text-xs py-0 px-0"
          >
            用 <FaHeart className="inline text-red-500 mx-1 text-xs" /> 制作
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
